module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw TitlePage-rw exclude-print-rw",
    attrs: {
      "epub:type": "frontmatter titlepage",
      "id": "BookTitlePage1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page-v"
    }
  }), _vm._v("A HELL OF A WOMAN")]), _vm._v(" "), _c('h1', {
    staticClass: "author"
  }, [_vm._v("JIM"), _c('br'), _vm._v("THOMPSON")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/mulholland_logo_online.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Little, Brown and Company")]), _vm._v(" "), _c('p', {
    staticClass: "firstpara1"
  }, [_vm._v("New York   Boston   London")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fae8e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 60
// module chunks = 0